"use client";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Icon from "../icons/Icons";
import { openRequestCallback } from "@/redux/features/requestCallback/requestCallbackSlice";
import { useLoginModal } from "@/utils/useLoginModal";

export default function CallRequestButton() {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const { isLoggedIn } = useLoginModal();
  const shouldLoadScripts = process.env.NODE_ENV != "development";

  useEffect(() => {
    if (isLoggedIn) return;
    const timer = setTimeout(() => setShow(true), 3000);
    return () => clearTimeout(timer);
  }, [isLoggedIn]);

  // if (isLoggedIn) return;
  if (isLoggedIn || !shouldLoadScripts) return;

  return (
    <button
      onClick={() => dispatch(openRequestCallback({ reason: "Side Green Button", buttonType: "side_button" }))}
      aria-label="Open Modal to Request a Call Back From Us"
      className={`w-fit sm:w-full max-w-35 fixed z-1000 top-1/3 -right-5 text-white bg-[#0B5D22] border border-[#578F67] border-r-0 rounded-tl-xl rounded-bl-xl flex items-center justify-start gap-3 p-3.5 pr-7 sm:p-2.5 shadow-[-2px_6px_40px_0_#00000040] transform transition-transform duration-700 ${show ? "translate-x-0" : "translate-x-full"} `}
      style={{
        transitionTimingFunction: show ? "cubic-bezier(.34,1.56,.64,1)" : "ease",
      }}
    >
      <Icon.callIconV3 className="shrink-0" />
      <span className="hidden sm:inline text-2xs leading-1.3 font-medium text-left">Request a Callback...</span>
    </button>
  );
}
